import { useUser } from "@clerk/clerk-react";

export const useIsAdmin = () => {
  const { user } = useUser();
  
  // Check if user has superAdmin flag in Clerk's public metadata
  const isSuperAdmin = user?.publicMetadata?.superAdmin === true || user?.publicMetadata?.superAdmin === "true";
  
  return {
    isSuperAdmin,
    isAdmin: isSuperAdmin, // For backwards compatibility
  };
};